(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setAnnouncementHeight();
      const debouncedOnChange = debounce(() => {
        this.setAnnouncementHeight();
      }, ON_CHANGE_DEBOUNCE_TIMER);
      window.addEventListener('resize',debouncedOnChange.bind(this));
    }

    setAnnouncementHeight() {
      const height = this.offsetHeight;
      if (height > 0) {
        document.documentElement.style.setProperty('--announcement-height', `${height}px`);
      }
    }
  }

  customElements.define('announcement-utility-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-links"] && !Shopify.designMode) return;
  try {
    
  class CollectionListLinks extends HTMLElement {
    constructor() {
      super();
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.collectionItems = this.querySelectorAll('.collection-list__item');
      this.images = this.querySelectorAll('.collection-list-links__media');
      this.collapsibleIndicators = this.querySelectorAll('.collection-list__expand-indicator');
      this.currentItem = null;
      this.currentImage = null;

      this.attachEventListeners();
    }

    attachEventListeners() {
      this.collectionItems.forEach((item) => {
        item.addEventListener('click', () => {
          if (event.target.tagName === 'A' && event.target.classList.contains('collection-list__subnav-link')) {
            return;
          }

          if (this.mediaQuery.matches) {
            this.handleInteraction(item);
          } else {
            const anchor = item.querySelector('.collection-list__item-toggle');
            if (anchor) {
              event.preventDefault();
            }
            this.handleInteraction(item);
          }
        });

        item.addEventListener('mouseover', () => {
          if (this.mediaQuery.matches) {
            this.handleInteraction(item);
          }
        });
      });
    }

    handleInteraction(item) {
      const collectionHandleized = item.getAttribute('data-collection');
      const thisCollapseIndicator = item.querySelector('.collection-list__expand-indicator');

      this.updateItemState(item, collectionHandleized, thisCollapseIndicator);
    }

    updateItemState(item, collectionHandleized, thisCollapseIndicator) {
      const isCollapsed = !item.classList.contains('is-collapsed');

      this.collectionItems.forEach((otherItem) => {
        otherItem.classList.add('is-collapsed');
      });

      if (!isCollapsed) {
        item.classList.remove('is-collapsed');
      }

      this.images.forEach((image) => {
        if (image.getAttribute('data-collection') === collectionHandleized) {
          image.classList.add('is-visible');
          this.currentImage = image;
        } else {
          image.classList.remove('is-visible');
        }
      });

      this.updateCollapseIndicators(thisCollapseIndicator, isCollapsed);
      this.currentItem = item;
    }

    updateCollapseIndicators(thisCollapseIndicator, isCollapsed) {
      this.collapsibleIndicators.forEach((indicator) => {
        indicator.innerHTML = '[ + ]';
      });

      if (!isCollapsed) {
        thisCollapseIndicator.innerHTML = '[ – ]';
      }
    }
  }

  customElements.define('collection-list-component', CollectionListLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["context-choice-popup"]) return;
  try {
    
  class AutoOpenModalDialog extends ModalDialog {
    constructor() {
      super();
      this.contextChoice = localStorage.getItem('contextChoice');
      this.body = document.body;
      this.bodyContextAttribute = 'data-context';
      this.currentContextSpan = document.querySelector('[data-current-context]');
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);

      const headerContextToggle = document.querySelector('[data-current-context]');

      const contextChoice = localStorage.getItem('contextChoice');
      if (!contextChoice || contextChoice === 'null') {
        this.show();
      }

      this.buttons = this.querySelectorAll('[data-context-choice]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const contextChoiceValue = button.getAttribute('data-context-choice');
          localStorage.setItem('contextChoice', contextChoiceValue);
          this.hide();
          this.updateContext(contextChoiceValue);
        });
      });
    }

    updateContext(contextChoiceValue) {
      this.body.setAttribute(this.bodyContextAttribute, contextChoiceValue);
      if (this.currentContextSpan) {
        this.currentContextSpan.textContent = contextChoiceValue;
        this.currentContextSpan.closest('summary').setAttribute('aria-label', contextChoiceValue);
      }
    }
  }

  customElements.define('auto-open-modal-dialog', AutoOpenModalDialog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.body = document.body;
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1299px)').addEventListener('change', this.setHeaderHeight.bind(this)); // breakpoint for full view

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.darkSections = Array.from(document.querySelectorAll('.section-is-dark'));
      this.requestAnimationId = null;
      window.addEventListener('scroll', this.handleIntersectionScroll.bind(this));
      this.handleIntersectionScroll();
    }

    handleIntersectionScroll() {
      if (this.requestAnimationId) {
        cancelAnimationFrame(this.requestAnimationId); // Cancel previous animation frame
      }

      this.requestAnimationId = requestAnimationFrame(() => {
        const stickyRect = this.header.getBoundingClientRect();
        const isHeaderIntersecting = this.darkSections.some((targetDiv) => {
          // Now checks both offsetParent AND display style
          if (targetDiv.offsetParent !== null && getComputedStyle(targetDiv).display !== 'none') {
            const targetRect = targetDiv.getBoundingClientRect();
            return stickyRect.bottom >= targetRect.top && stickyRect.top <= targetRect.bottom;
          }
          return false;
        });

        if (isHeaderIntersecting) {
          this.header.classList.add('header--light');
        } else {
          this.header.classList.remove('header--light');
        }

        this.requestAnimationId = requestAnimationFrame(this.handleIntersectionScroll.bind(this));
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight > 58 ? this.header.offsetHeight : 58}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.body.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.body.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.body.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MegaMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addLevel1EventListeners();
      document.addEventListener('newDetailsMenuOpened', this.handleNewMenuOpened.bind(this));
    }

    handleNewMenuOpened(event) {
      this.resetMegaMenu();
    }

    addLevel1EventListeners() {
      const level1Links = this.querySelectorAll('.mega-menu__link--level-1');
      let isDesktop = window.matchMedia('(min-width: 990px)').matches;

      const handleLevel1Mouseover = (event) => {
        if (event.target.classList.contains('mega-menu__link--level-1-has-children')) {
          event.preventDefault();
        }

        if (event.target.classList.contains('mega-menu__link--active')) {
          // already active so collapse it all
          this.resetMegaMenu();
        } else {
          // Close all others and open the child
          this.resetMegaMenu();
          event.target.classList.add('mega-menu__link--active');
          this.classList.add('has-active-menu-2');
          if (!event.target.classList.contains('mega-menu__link--level-1-has-children')) return;
          const level2Ul = event.target.nextElementSibling;
          if (level2Ul && level2Ul.classList.contains('mega-menu__list--lv2')) {
            this.toggleMenuLevel2(level2Ul);
          }
        }
      };

      const handleLevel1Click = (event) => {
        if (event.target.classList.contains('mega-menu__link--level-1-has-children')) {
          event.preventDefault();
        }

        if (event.target.classList.contains('mega-menu__link--active')) {
          // already active so collapse it all
          this.resetMegaMenu();
        } else {
          // Close all others and open the child
          this.resetMegaMenu();
          this.classList.add('has-active-menu-2');
          event.target.classList.add('mega-menu__link--active');
          if (!event.target.classList.contains('mega-menu__link--level-1-has-children')) return;
          const level2Ul = event.target.nextElementSibling;
          if (level2Ul && level2Ul.classList.contains('mega-menu__list--lv2')) {
            this.toggleMenuLevel2(level2Ul);
          }
        }
      };

      const addDesktopEventListeners = () => {
        level1Links.forEach((link) => {
          link.removeEventListener('click', handleLevel1Click);
          link.addEventListener('mouseover', handleLevel1Mouseover);
        });
      };

      const addMobileEventListeners = () => {
        level1Links.forEach((link) => {
          link.removeEventListener('mouseover', handleLevel1Mouseover);
          link.addEventListener('click', handleLevel1Click);
        });
      };

      if (isDesktop) {
        addDesktopEventListeners();
      } else {
        addMobileEventListeners();
      }

      // Call function to add level 2 event listeners
      this.addLevel2EventListeners();

      // Add event listener to update event listeners on resize
      window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
        if (event.matches) {
          addDesktopEventListeners();
        } else {
          addMobileEventListeners();
        }
      });
    }

    toggleMenuLevel2(menuElement) {
      menuElement.classList.toggle('show');
    }

    addLevel2EventListeners() {
      const level2Links = this.querySelectorAll('.mega-menu__link--level-2');
      let isDesktop = window.matchMedia('(min-width: 990px)').matches;

      const handleLevel2Mouseover = (event) => {
        if (event.target.classList.contains('mega-menu__link--level-2-has-children')) {
          event.preventDefault();
        }

        if (event.target.classList.contains('mega-menu__link--active')) {
          // already active so collapse it all
          this.closeAllLevel3Menus();
        } else {
          // Close all others and open the child
          this.closeAllLevel3Menus();
          event.target.classList.add('mega-menu__link--active');
          this.classList.add('has-active-menu-3');
          if (!event.target.classList.contains('mega-menu__link--level-2-has-children')) return;
          const level3Ul = event.target.nextElementSibling;
          if (level3Ul && level3Ul.classList.contains('mega-menu__list--lv3')) {
            this.toggleMenuLevel3(level3Ul);
          }
        }
      };

      const handleLevel2Click = (event) => {
        if (event.target.classList.contains('mega-menu__link--level-2-has-children')) {
          event.preventDefault();
        }

        if (event.target.classList.contains('mega-menu__link--active')) {
          // already active so collapse it all
          this.closeAllLevel3Menus();
        } else {
          // Close all others and open the child
          this.closeAllLevel3Menus();
          event.target.classList.add('mega-menu__link--active');
          this.classList.add('has-active-menu-3');
          if (!event.target.classList.contains('mega-menu__link--level-2-has-children')) return;
          const level3Ul = event.target.nextElementSibling;
          if (level3Ul && level3Ul.classList.contains('mega-menu__list--lv3')) {
            this.toggleMenuLevel3(level3Ul);
          }
        }
      };

      const addDesktopEventListeners = () => {
        level2Links.forEach((link) => {
          link.removeEventListener('click', handleLevel2Click);
          link.addEventListener('mouseover', handleLevel2Mouseover);
        });
      };

      const addMobileEventListeners = () => {
        level2Links.forEach((link) => {
          link.removeEventListener('mouseover', handleLevel2Mouseover);
          link.addEventListener('click', handleLevel2Click);
        });
      };

      if (isDesktop) {
        addDesktopEventListeners();
      } else {
        addMobileEventListeners();
      }

      // Add event listener to update event listeners on resize
      window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
        isDesktop = event.matches;
        if (isDesktop) {
          addDesktopEventListeners();
        } else {
          addMobileEventListeners();
        }
      });
    }

    toggleMenuLevel3(menuElement) {
      menuElement.classList.toggle('show');
    }

    clearActiveLevel1Links() {
      const level1Links = this.querySelectorAll('.mega-menu__link--level-1');
      level1Links.forEach((link) => {
        link.classList.remove('mega-menu__link--active');
      });
    }

    closeAllLevel2Menus() {
      const level2Menus = this.querySelectorAll('.mega-menu__list--lv2');
      level2Menus.forEach((menu) => {
        menu.classList.remove('show');
      });
    }

    clearActiveLevel2Links() {
      const level2Links = this.querySelectorAll('.mega-menu__link--level-2');
      level2Links.forEach((link) => {
        link.classList.remove('mega-menu__link--active');
      });
    }

    closeAllLevel3Menus() {
      this.classList.remove('has-active-menu-3');
      this.clearActiveLevel2Links();
      const level3Menus = this.querySelectorAll('.mega-menu__list--lv3');
      level3Menus.forEach((menu) => {
        menu.classList.remove('show');
      });
    }

    resetMegaMenu() {
      this.classList.remove('has-active-menu-2');
      this.classList.remove('has-active-menu-3');
      this.clearActiveLevel1Links()
      this.closeAllLevel2Menus();
      this.clearActiveLevel2Links();
      this.closeAllLevel3Menus();
    }
  }

  customElements.define('mega-menu', MegaMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class ImageBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.target.nodeName === 'HTML') {
            const style = window.getComputedStyle(this);
            const height = style.getPropertyValue('height');
            if (height !== 'auto') {
              this.style.height = '';
              observer.disconnect();
            }
          }
        }
      });

      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    }
  }

  customElements.define('image-banner', ImageBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brand-designer-directory"] && !Shopify.designMode) return;
  try {
    
  class StickyUtils extends HTMLElement {
    constructor() {
      super();
      this.stickyBar = this;
      this.anchors = this.querySelectorAll('a[href^="#"]');
      this.tabButtons = this.querySelectorAll('.directory__tab');
      this.headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      this.setStickyUtilsHeight();
    }

    connectedCallback() {
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setStickyUtilsHeight.bind(this));
      this.anchors.forEach((anchor) => {
        anchor.addEventListener('click', this.handleAnchorClick.bind(this));
      });

      this.tabButtons.forEach((tabButton) => {
        tabButton.addEventListener('click', this.handleTabClick.bind(this));
      });

      this.checkAndActivateTabFromQueryParam();
    }

    setStickyUtilsHeight() {
      document.documentElement.style.setProperty('--sticky-utils-height', `${this.stickyBar.offsetHeight}px`);
    }

    handleAnchorClick(event) {
      event.preventDefault();

      const targetId = event.target.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-utils-height'));
        const combinedOffset = offset + this.headerHeight;

        window.scroll({
          top: targetElement.offsetTop + combinedOffset * 2,
          behavior: 'smooth',
        });
      }
    }

    handleTabClick(event) {
      // Scroll to top, in addition to the global functionality applied to these tab buttons
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }

    checkAndActivateTabFromQueryParam() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const tabParam = urlSearchParams.get('tab');

      if (tabParam) {
        this.tabButtons.forEach((tabButton) => {
          tabButton.setAttribute('aria-pressed', 'false');
        });

        const matchingTabButton = Array.from(this.tabButtons).find(
          (tabButton) => tabButton.textContent.trim().toLowerCase() === tabParam.toLowerCase()
        );

        if (matchingTabButton) {
          setTimeout(() => {
            matchingTabButton.click();
          }, 100);
        }
      }
    }
  }

  customElements.define('sticky-utils', StickyUtils);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class SectionProductInfoInner extends HTMLElement {
    constructor() {
      super();

      this.product = null;
      this.headerHeight = 0;
      this.switchPoint = 0;

      this.updateSwitchPoint = this.updateSwitchPoint.bind(this);
      this.updateProductPosition = this.updateProductPosition.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.product = this.querySelector('.product');
      this.headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));

      this.updateSwitchPoint();
      this.updateProductPosition();

      document.addEventListener('mediaSwiperInitialized', () => {
        this.updateSwitchPoint();
        this.updateProductPosition();
      });

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    updateSwitchPoint() {
      const section = this.parentElement;
      this.switchPoint = section.offsetTop - this.product.clientHeight - this.headerHeight;
    }

    updateProductPosition() {
      const scrollY = window.scrollY;

      if (scrollY >= this.switchPoint) {
        this.product.classList.add('is-stuck');
      } else {
        this.product.classList.remove('is-stuck');
      }
    }

    handleScroll() {
      if (!this.animationFrameId) {
        this.animationFrameId = requestAnimationFrame(() => {
          this.updateProductPosition();
          this.animationFrameId = null;
        });
      }
    }

    handleResize() {
      this.updateSwitchPoint();
      this.handleScroll();
    }
  }

  customElements.define('section-product-info-inner', SectionProductInfoInner);

  } catch(e) { console.error(e); }
})();
})();
